import { useEffect } from "react";
import { useLogout, useNotify } from "ra-core";

import { supabase } from "@/components/atomic-crm/providers/supabase/supabase";

/**
 * Uma sessão por pessoa (migration 282): quando a mesma conta entra em outro
 * lugar, esta tela sai. Pergunta ao banco a cada minuto e ao voltar o foco;
 * quem é da North e a conta de demonstração ficam de fora (o banco responde
 * sempre true para eles).
 *
 * Erro de rede ou função ainda inexistente NÃO derruba ninguém: só um `false`
 * explícito encerra a sessão.
 */
export const useSessaoUnica = () => {
  const logout = useLogout();
  const notify = useNotify();

  useEffect(() => {
    let ativo = true;
    let saindo = false;
    const conferir = async () => {
      if (saindo || document.visibilityState === "hidden") return;
      const { data, error } = await supabase.rpc("sessao_ainda_vale" as never);
      if (!ativo || error || data !== false) return;
      saindo = true;
      notify("Sessão encerrada: a conta entrou em outro dispositivo.", { type: "warning" });
      logout();
    };
    const timer = window.setInterval(conferir, 60_000);
    window.addEventListener("focus", conferir);
    void conferir();
    return () => {
      ativo = false;
      window.clearInterval(timer);
      window.removeEventListener("focus", conferir);
    };
  }, [logout, notify]);
};
